import { FormattedMessage } from "react-intl";
import { Box, Button, Grid, Icon, Text } from "@chakra-ui/react";
import { AiFillBank } from "react-icons/ai";
import { useGenerateUrlAndRedirectUser } from "./useGenerateUrlAndRedirectUser";

const AddPlaidACHButton = ({ newUI, description }) => {
  const { onGenerateUrlAndRedirectUser, isOpen } = useGenerateUrlAndRedirectUser();

  if (newUI) {
    return (
      <Box p="4" boxShadow="base" cursor="pointer" onClick={onGenerateUrlAndRedirectUser}>
        <Grid templateColumns="20px 1fr" gridGap="2" alignItems="center">
          <Icon as={AiFillBank} boxSize="5" color="integrator.500" />
          <Text fontWeight="bold">
            <FormattedMessage defaultMessage="Bank" description="Button label" />
          </Text>
          <Box />
          <Box>{description}</Box>
        </Grid>
      </Box>
    );
  }

  return (
    <Button
      data-testid="add-bank-button"
      variant="outline"
      colorScheme="gray"
      onClick={onGenerateUrlAndRedirectUser}
      width="full"
      isDisabled={isOpen}
    >
      <FormattedMessage defaultMessage="Add Bank Account" description="Button label" />
    </Button>
  );
};

export default AddPlaidACHButton;
